// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1VfP1","header":"MergedInvoice_header__dwmGE"};